import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading',
  template: `<div
                class="loading d-flex justify-content-center"
                [style.padding-top]="topPercent + '%'"
              >
              <img
                class="spin-ball"
                src="assets/img/loading.svg"
                >
            </div>`,
  styles: [`
    .loading {
      position: absolute;
      z-index: 1;
      width: 100%;
      top: 0;
      left: 0;
      height: 100%;
      background: rgba(255,255,255,0.7);
    }
    img {
      width: 50px;
      height: 50px;
    }
  `]
})
export class LoadingComponent {
  @Input() topPercent = 30

  constructor() { }
}